export default __webpack_public_path__ + "static/media/gua.9e5227e7.jpg";